<template>
  <div>
    <LoadingSpinner :visible="isLoading" />
    <!----------------- Main contents Area --------------------->
    <!-- mt-3: margin top-3 -->
    <main class="mt-3">
      <div class="pl-1 text-center">
        <div class="alert alert-info" role="alert">
          <b class="fs-4">쿠 폰 생 성 & 리 스 트</b>
        </div>
        <div class="float-start mb-2">
          <!-- <button type="button" class="btn btn-info" @click="showMakeCoupon">Coupon생성</button> -->
          <span class="fs-6 fw-bold text-primary">[ 쿠 폰 생 성 ]</span>
          <span> 
            쿠폰번호: <span style="color: red; font-weight: 600;">{{ this.cpCode }}</span> / 발행수량:&nbsp; 
            <!-- <span v-if="this.cpIssueQty == ''"></span> -->
            <span v-if="this.firstQty == 0">관리X</span>
            <span v-else-if="this.firstQty > 0" class="text-success">{{ this.firstQty }}</span>
            <span v-else-if="this.firstQty < 0">수량체크가 필요합니다!</span>
          </span>&nbsp;&nbsp;&nbsp;
          <button type="button" class="btn btn-success btn-sm" style="font-size: small;" @click="pageReload">초기화</button>
        </div>

        <!-- make coupon area -->
        <table class="table table-bordered">
          <thead>
            <tr style="background-color: lightgray;">
              <th style="font-size: 1rem; font-weight: 600; width:10%;">1. 쿠폰상태</th>
              <th style="font-size: 1rem; font-weight: 600; width:10%;">2. 적용대상</th>
              <th style="font-size: 1rem; font-weight: 600; width:10%;">3. 발행대상</th>
              <th style="font-size: 1rem; font-weight: 600; width:20%;">4. 쿠폰명</th>
              <th style="font-size: 1rem; font-weight: 600; width:10%;">5. 적용금액</th>
              <th style="font-size: 1rem; font-weight: 600; width:5%;">6. 수량</th>
              <th style="font-size: 1rem; font-weight: 600; width:8%;">7. 발행일자</th>
              <th style="font-size: 1rem; font-weight: 600; width:8%;">8. 사용기한</th>
              <th style="font-size: 1rem; font-weight: 600; width:8%;">9. 발행자</th>
              <th style="font-size: 1rem; font-weight: 600; width:15%;">10. 필수확인사항</th>
              <th style="font-size: 1rem; font-weight: 600; width:5%;">11. 생성</th>
            </tr>
          </thead>
          <tbody>
            <tr style="vertical-align: middle;">
              <td>
                <select class="form-select form-select-sm" aria-label=".form-select-sm" ref="sel_cpActive" v-model="this.cpActive">
                  <option value="active">활성쿠폰 (즉시사용가능)</option>
                  <option value="inactive">비활성쿠폰 (등록 후 사용가능)</option>
                </select>
              </td>

              <!-- 쿠폰적용대상 -->
              <td>
                <select class="form-select form-select-sm" aria-label=".form-select-sm" ref="sel_cpUseCode" v-model="this.cpUseCode" @change="show_cpUseCodeList(this.cpUseCode, '')">
                  <option value="AL">전체상품</option>
                  <option value="CA">특정카테고리</option>
                  <option value="PD">특정상품</option>
                </select>
              </td>

              <!-- 쿠폰발행대상 -->
              <td>
                <select class="form-select form-select-sm" aria-label=".form-select-sm" ref="sel_cpType" v-model="this.cpType"  @change="show_cpTypeList(this.cpType, '')" :disabled="this.cpActive === 'inactive'">
                  <option value="mAll">전체회원</option>
                  <option value="pAll">프리미엄멤버</option>
                  <option value="sAll">스탠다드멤버</option>
                  <option value="sMem">특정회원</option>
                  <!-- <option value="uAll">전체유저(비회원포함)</option>
                  <option value="nMem">회원가입조건</option> -->
                </select>
              </td>
              <td>
                <input type="text" v-model="this.cpName" style="font-size:0.9rem" maxlength="40" ref="cpName" placeholder="50자 이내">
              </td>
              <td>
                <div class="d-flex justify-content-center align-items-center">
                  <input type="number" v-model="this.cpPrice" style="font-size:0.9rem; height:28px; width:55%" maxlength="10" ref="cpPrice">
                  <select class="form-select form-select-sm" aria-label=".form-select-sm" style="font-size:0.9rem; height:28px; width:30%;" ref="sel_cpPriceFlag" v-model="this.cpPriceFlag">
                    <option value="A" style="color:red;">원</option>
                    <option value="R" style="color:blue;">%</option>
                  </select>
                </div>
              </td>
              <td>
                <input type="number" v-model="this.firstQty" style="font-size:0.9rem; height:28px; width:70%" maxlength="10" ref="firstQty">
              </td>
              <td>
                <input type="date" v-model="this.cpIssueDate" style="font-size:0.9rem;" ref="cpIssueDate">
              </td>
              <td>
                <input type="date" v-model="this.cpExpDate" style="font-size:0.9rem;" ref="cpExpDate">
              </td>
              <td>
                <input type="text" v-model="this.cpIssuer" style="font-size:0.9rem;" ref="cpIssuer">
              </td>
              <td>
                <textarea class="form-control" placeholder="300자 이내" ref="cpRemarks" id="floatingTextarea" style="height:60px; font-size:0.7rem;" v-model="this.cpRemarks" maxlength="300"></textarea>
              </td>
              <td>
                <button type="button" class="btn btn-primary btn-md" @click="makeCoupon">생성</button>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- 선택된 파라메타 stock -->
        <table id="stockTable" class="col-12">
          <tr>
            <td class="stockTable col-6" style="background-color: blanchedalmond;">
              <!-- 적용대상 chips 표시 -->
              <div class="chips-container">
                <span v-for="(item, idx) in selectedCpUseArray" :key="item" class="chip">
                  {{ item.name }}
                  <button type="button" class="chip-close" @click="removeCpUse(idx)"><i class="bi bi-x-circle" style="font-size: 0.8rem;"></i></button>
                </span>
              </div>
            </td>
            <td class="stockTable col" style="background-color: darkseagreen;">
              <!-- 발행대상 chips 표시 -->
              <div class="chips-container">
                <span v-for="(item, idx) in selectedcpTypeArray" :key="item" class="chip">
                  {{ item.memName }} ({{ item.memId }})
                  <button type="button" class="chip-close" @click="removeCpType(idx)"><i class="bi bi-x-circle" style="font-size: 0.8rem;"></i></button>
                </span>
              </div>
            </td>
          </tr>
        </table>

        <table style="width: 100%;">
          <tr>
            <td style="vertical-align: top; width: 50%;">
              <!-- 적용대상(사용조건) 선택 cpUseCode -->
              <div v-if="this.show_cpUseCode == 'Y'">
                <div class="mb-1 input-group" v-if="this.cpUseCode === 'PD'">
                  <select class="form-select form-select-sm" aria-label=".form-select-sm" ref="sel_catCode" v-model="this.catCode" @change="changeCatCode(catCode)">
                    <option :value="noVal" disabled>상품카테고리</option>
                    <option value="A">전체보기</option>
                    <option :value="ac.baseCode" :key="i" v-for="(ac, i) in this.pdtCategoryList">{{ ac.codeNameKor }}</option>
                  </select>&nbsp;&nbsp;&nbsp;
                  <input type="text" v-model="this.keyWord_cu" style="font-size:0.9rem; background-color: beige; width: 350px;" ref="cpName" placeholder="상품명">
                  <button type="button" class="btn btn-warning btn-sm" style="font-size: smaller;" @click="searchProduct(this.keyWord_cu, 'CU', 'search')">검색</button>
                </div>
                <div class="text-end mb-1">
                  <button type="button" class="btn btn-outline-danger btn-sm" style="font-size: smaller;" @click="saveTemp_selItems(this.cpUseCode, 'CU')">선택저장</button>
                </div>

                <table class="table table-bordered table-striped">
                  <thead>
                    <tr style="background-color: lightgray; width:50%; font-size: 1rem;">
                      <th style="width:5%;">
                        <input class="form-check-input" type="checkbox" style="width: 15px;" v-model="this.allSelected" @change="allChoice('CU')" />
                      </th>

                      <th style="font-size: 1rem; font-weight: 600;" v-if="this.cpUseCode === 'CA'">카테고리</th>
                      <th style="font-size: 1rem; font-weight: 600;" v-else-if="this.cpUseCode === 'PD'">상품</th>
                      <!-- <th style="font-size: 1rem; font-weight: 600; width:5%;">적용</th> -->
                    </tr>
                  </thead>
                  <tbody class="small">
                    <tr :key="i" v-for="(cu, i) in this.cpUseCodeList">
                      <td>
                        <div v-if="this.cpUseCode === 'CA'">
                          <input type="checkbox" ref="chb_Seq" class="align-baseline mt-3" style="width: 15px;"  :id=i name="checkedBox" v-model="cu.checkFlag">
                        </div>
                        <div v-else-if="this.cpUseCode === 'PD'">
                          <input type="checkbox" ref="chb_Seq" class="align-baseline mt-3" style="width: 15px;"  :id=i name="checkedBox" v-model="cu.checkFlag">
                        </div>                  
                      </td>
                      <td style="padding-left: 10px;">
                        <div class="text-start" v-if="this.cpUseCode === 'CA'">
                          <span class="fw-bold fs-6">{{ cu.codeNameKor}} ({{ cu.baseCode }})</span>
                        </div>
                        <div class="text-start" v-else-if="this.cpUseCode === 'PD'">
                          <span class="text-danger fst-italic">[{{ cu.codeNameKor }}]</span>&nbsp;&nbsp;<span class="fw-bold">{{ cu.pdtNameKor}}</span><span style="font-size:smaller; color:darkgray;">({{ cu.pdtCode }})</span>&nbsp;&nbsp;<span style="font-size:smaller; color:blue;">{{ this.getCurrencyFormat(cu.minPrice) }} ~ {{ this.getCurrencyFormat(cu.maxPrice) }}원</span>
                        </div>                
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>

            <td style="vertical-align: top; width: 50%;">
              <!-- cpType 발행대상리스트: 회원명부 -->
              <div class="float-start mb-2" v-if="this.show_cpType === 'Y'">
                <div class="mb-1 input-group" v-if="this.cpType === 'sMem'">
                  <select class="form-select form-select-sm" aria-label=".form-select-sm" ref="sel_procCode" v-model="rProcCode" @change="changeProcCode(rProcCode)">
                    <option :value="noVal" disabled>회원분류</option>
                    <option value="A">전체보기</option>
                    <option value="Pre">프리미엄</option>        
                    <option value="Std">스탠다드</option>
                  </select>&nbsp;&nbsp;&nbsp;
                  <input type="text" v-model="this.keyWord_ct" style="font-size:0.9rem; background-color:lightgreen; width: 350px;" ref="memName" placeholder="회원성명">
                  <button type="button" class="btn btn-success btn-sm" style="font-size: smaller;" @click="searchProduct(this.keyWord_ct, 'CT', 'search')">검색</button>
                </div>
                <div class="text-end mb-1" v-if="this.cpType === 'sMem'">
                  <button type="button" class="btn btn-outline-success btn-sm" style="font-size: smaller;" @click="saveTemp_selItems(this.cpType, 'CT')">선택저장</button>
                </div>

              
                <!-- 회원리스트 -->
                <table class="table table-bordered table-striped fs-6 align-item-center"  v-if="this.cpType === 'sMem'">
                  <thead>
                    <tr style="background-color: lightgray;">
                      <th style="width:1%;">
                        <input class="form-check-input" type="checkbox" v-model="allSelected_ct" @change="allChoice('CT')" />
                      </th>
                      <th style="font-size: 1rem; font-weight: 600; width:5%;">멤버십</th>
                      <th style="font-size: 1rem; font-weight: 600; width:5%;">번호</th>
                      <th style="font-size: 1rem; font-weight: 600; width:9%;">아이디</th>
                      <th style="font-size: 1rem; font-weight: 600; width:8%;">성명</th>
                      <th style="font-size: 1rem; font-weight: 600; width:8%;">가입일</th>
                      <th style="font-size: 1rem; font-weight: 600; width:10%;">연락처/알림톡</th>
                      <th style="font-size: 1rem; font-weight: 600; width:8%;">생일</th>
                      <th style="font-size: 1rem; font-weight: 600; width:5%;">성별</th>
                      <th style="font-size: 1rem; font-weight: 600; width:6%;">포인트</th>
                      <th style="font-size: 1rem; font-weight: 600; width:15%;">비고사항</th>
                    </tr>
                  </thead>
                  <tbody class="small">
                    <tr :key="i" v-for="(m, i) in memberInfo" style="font-size:small;">
                      <td>
                        <input type="checkbox" v-model="m.checkFlag"  ref="chb_Seq" class="align-baseline mt-3" :id=i name="checkedBox">
                      </td>
                      
                      <td style="color:goldenrod" v-if="m.memLevel === 'P'">{{ m.memLv }}</td>
                      <td style="color:royalblue" v-else-if="m.memLevel === 'S'">{{ m.memLv }}</td>
                      <td style="color:royalblue" v-else></td>

                      <td>{{ m.memNo }}</td>

                      <td style="font-size: smaller">{{ m.uEmail }}</td>

                      <td>{{ m.uNickName }}</td>

                      <td v-if="m.insDate == undefined">미확인</td>
                      <td v-else class="text-secondary">{{ this.getDateFormat(m.insDate) }}</td>

                      <td>
                        {{ m.uPhone }}
                        <p>{{ m.alimCallC }}</p>
                      </td>
                      
                      <td>
                        {{ m.uBirthyear }}/{{ m.uBirthday }}
                      </td>

                      <td>{{ m.uGender }}</td>

                      <td v-if="m.memberPoint == undefined" class="text-secondary">0</td>
                      <td v-else class="text-primary">
                        {{ this.getCurrencyFormat(m.memberPoint) }}
                      </td>
                      
                      <td>{{ m.spRemarks }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </table>


        <!-- 발행쿠폰리스트 -->
        <div class="mb-1 input-group" style="width: 40%;">
          <select class="form-select form-select-sm" aria-label=".form-select-sm" ref="sel_procCode" v-model="this.sParam" @change="changeSearchCode(this.sParam)">
            <option value="" disabled>쿠폰종류</option>
            <!-- <option :value="{ value: p.value, type: p.type }" :key="i" v-for="(p, i) in this.sParam">{{ p.name }}</option> -->
            <option :value="{ value: p.value, type: p.type }" :key="i" v-for="(p, i) in this.sParam_array">{{ p.name }}</option>
          </select>&nbsp;&nbsp;
          <input type="text" v-model="this.keyWord_cp" style="font-size:0.9rem; background-color:lavender; width: 350px;" ref="memName" placeholder="쿠폰명">
          <button type="button" class="btn btn-outline-dark btn-sm" style="font-size: smaller; color:white; background-color: purple;" @click="searchCoupon(this.keyWord_cp)">검색</button>
        </div>
      
        <table class="table table-bordered table-striped fs-6 align-item-center">
          <thead>
            <tr style="background-color: lightgray;">
              <!-- <th style="width:1%;">
                <input class="form-check-input" type="checkbox" style="font-size:small;" v-model="allSelected" @change="allChoice()" />
              </th> -->
              <th style="font-size: 1rem; font-weight: 600; width:3%;">상태</th>
              <th style="font-size: 1rem; font-weight: 600; width:12%;">쿠폰명</th>
              <th style="font-size: 1rem; font-weight: 600; width:6%;">쿠폰코드</th>
              <th style="font-size: 1rem; font-weight: 600; width:5%;">적용금액</th>
              <th style="font-size: 1rem; font-weight: 600; width:5%;">적용대상</th>
              <th style="font-size: 1rem; font-weight: 600; width:5%;">발행대상</th>
              <th style="font-size: 1rem; font-weight: 600; width:6%;">발행일</th>
              <th style="font-size: 1rem; font-weight: 600; width:6%;">기한일</th>
              <th style="font-size: 1rem; font-weight: 600; width:3%;">발행</th>
              <th style="font-size: 1rem; font-weight: 600; width:3%;">등록</th>
              <th style="font-size: 1rem; font-weight: 600; width:3%;">사용</th>
              <th style="font-size: 1rem; font-weight: 600; width:6%;">발행인</th>
              <th style="font-size: 1rem; font-weight: 600; width:6%;">담당자</th>
              <th style="font-size: 1rem; font-weight: 600; width:15%;">비고사항</th>
              <th style="font-size: 1rem; font-weight: 600; width:5%;">기능</th>
            </tr>
          </thead>
          <tbody class="small">
            <tr :key="i" v-for="(m, i) in this.issuedCpList" style="font-size:small;">
              <!-- <td>
                <input type="checkbox" v-model="m.checkFlag"  ref="chb_Seq" class="align-baseline mt-3" :id=i name="checkedBox">
              </td> -->
              
              <td v-if="m.cpActive === 'Y'">활성</td>
              <td style="color:darkgray" v-else-if="m.cpActive === 'N'">비활성</td>
              <td style="color:royalblue" v-else>??</td>

              <td class="text-start">{{ m.cpName }}</td>
              <td style="font-size: smaller">{{ m.cpCode }}</td>

              <td v-if="m.cpPriceFlag == 'A'" style="color:red;">{{ this.getCurrencyFormat(m.cpPrice) }}원</td>
              <td v-else-if="m.cpPriceFlag == 'R'" style="color:blue;">{{ this.getCurrencyFormat(m.cpPrice) }}%</td>
              <td v-else><i class="bi bi-exclamation-triangle-fill text-danger fs-5"></i></td>

              <td v-if="m.cpUseCode == 'AL'" class="tooltip">전체상품</td>
              <td v-else-if="m.cpUseCode == 'AU'">전체유저</td>
              <td v-else-if="m.cpUseCode == 'CA'" style="cursor: pointer;" @click="checkData('CA', m.cpCode, $event)"><i class="bi bi-search text-primary"></i>특정카테고리</td>
              <td v-else-if="m.cpUseCode == 'PD'" style="cursor: pointer;" @click="checkData('PD', m.cpCode, $event)"><i class="bi bi-search text-primary"></i>특정상품</td>
              <td v-else></td>
              <td v-if="m.cpType == 'mAll'">전체회원</td>
              <td v-else-if="m.cpType == 'pAll'">프리미엄</td>
              <td v-else-if="m.cpType == 'sAll'">스탠다드</td>
              <td v-else-if="m.cpType == 'sMem'" style="cursor: pointer;" @click="checkData('sMem', m.cpCode, $event)"><i class="bi bi-search text-success"></i>특정회원</td>
              <td v-else-if="m.cpType == 'uAll'">전체(비회원포함)</td>
              <td v-else-if="m.cpType == 'nMem'">회원가입조건</td>
              <td v-else></td>
              
              <td>
                {{ this.getDateFormat(m.cpIssueDate) }}
              </td>
              <td>{{ this.getDateFormat(m.cpExpDate) }}</td>

              <!-- 유한발행 -->
              <td v-if="m.cpIssueQtyIndef == 'N'">
                <span>{{ this.getCurrencyFormat(m.firstQty) }}</span> 
              </td>
              <!-- 비활성 + 무제한 -->
              <td v-else-if="m.cpActive == 'N' && m.cpIssueQtyIndef == 'Y'">
                <span><i class="bi bi-infinity fs-6"></i></span>
              </td>
              <!-- 활성 + 무제한 -->
              <td v-else-if="m.cpActive == 'Y' && m.cpIssueQtyIndef == 'Y'"></td>
              <!-- 활성 + 유한 -->
              <td v-else></td>
              
              <!-- 등록수량 -->
              <td v-if="m.cpActive == 'N'">
                <span class="text-success">{{ this.getCurrencyFormat(m.cpIssueQty) }}</span>
              </td>
              <td v-else></td>

              <!-- 사용수량 -->
              <td>
                <span class="text-danger">{{ this.getCurrencyFormat(m.usedQty) }}</span>
              </td>

              <td>{{ m.cpIssuer }}</td>
              <td>{{ m.handlerNameKor }}</td>
              <td>
                <span style="text-align: left;">
                  <pre>{{ m.cpRemarks }}</pre>
                </span>
              </td>
              <td>
                <button class="btn btn-outline-danger btn-sm" v-if="m.cpValidFlag=='Y'" @click="changeCpStatus(m.cpCode, 'N')"><span>無效化</span></button>
                <button class="btn btn-danger btn-sm" v-else @click="changeCpStatus(m.cpCode, 'Y')"><span>有效化</span></button>
                &nbsp;
                <button class="btn btn-outline-warning btn-sm" disabled><span style="color:black;">알림톡</span></button>
                <!-- <button class="btn btn-danger btn-sm" v-else-if="m.cpValidFlag=='N'" disabled><i class="bi bi-sign-stop-fill"></i></button> -->
              </td>
            </tr>
          </tbody>
        </table>

        <!-- 레이어 팝업 -->
        <div v-if="showLayer" class="data-layer" :style="layerStyle">
          <div class="layer-content">
            <button @click="closeLayer" class="close-btn"><i class="bi bi-x-circle-fill"></i></button>
            <div class="layerData">
              <!-- {{ layerData.join(', ') }} -->
              {{ layerData && layerData.length ? layerData.join(', ') : '로딩 중...' }}
            </div>
          </div>
        </div>

      </div>
    </main>
  </div>
</template>

<script>
import { handlerInfo } from '../assets/js/commonFunctions'
import LoadingSpinner from '../components/LoadingSpinner.vue'
import {generateCouponCode} from '../assets/js/genCode'
import dayjs from "dayjs";

export default {
  components: {
    LoadingSpinner
  },
  data() {
    return {
      isLoading: false,

      show_cpUseCode: "N",      //쿠폰발행대상 리스트 표시여부
      cpUseCodeList: [],        //쿠폰적용대상 리스트
      cpUseCodeList_org: [],    //쿠폰적용대상 리스트 원형리스트

      keyWord: "",              //상품명 검색용
      pdtCategoryList: [],      //상품카테고리 리스트
      catCode: "",              //상품카테고리코드

      show_cpType: "N",         //쿠폰발행대상 리스트 표시여부
      memberInfo: [],           //회원정보
      memberInfo_org: [],       //조건별 소팅용 원형리스트
      
      allSelected: "N",         //전체체크여부(적용대상)
      allSelected_ct: "N",      //전체체크여부(발행대상)

      //선택된 coupon's properties
      cpActive: "",             //쿠폰 활성 || 비활성
      cpUseCode: "",            //쿠폰적용대상
      cpType: "",               //쿠폰발행대상
      cpName: "",               //쿠폰명
      cpPrice: 0,               //쿠폰적용금액
      cpPriceFlag: "",          //쿠폰적용금액 단위(A/R)
      firstQty: 0,              //최초발행수량
      cpIssueQty: 0,            //쿠폰등록수량
      cpIssueDate: dayjs().format('YYYY-MM-DD'),  //쿠폰발행일자(기본값: today)
      cpExpIndef: "",           //쿠폰사용기한무제한여부(무제한:Y/N)
      cpExpDate: "",            //쿠폰사용기한
      cpIssuer: "엔타비글로벌",   //쿠폰발행자
      cpRemarks: "",            //쿠폰비고사항

      //// 적용대상(CA)과 발행대상(sMem)이 멀티선택인 경우 -> 디테일테이블에 배열형 문자열로 저장
      selectedCpUse: "",        //선택된 적용대상
      selectedCpUseArray: [],   // chips용 배열
      //selectedCpUseStack: [],   // 누적용 배열 추가

      selectedcpType: "",       //선택된 발행대상
      selectedcpTypeArray: [],  // 발행대상 chips용 배열

      selectedMemId_array: [],  //선택된 발행대상(회원아이디: send용 배열)

      issuedCpList: [],         //발행된 쿠폰리스트
      issueCpList_org: [],      //발행된 쿠폰리스트-org
      
      sParam: "",               //선택된 파라메타
      sParam_array: [           //선택용 파라메타배열
        { value:"All" , type:"aL"   , name: "전체보기" },
        { value:"Y"   , type:"cA" , name: "활성쿠폰" },
        { value:"N"   , type:"cA" , name: "비활성쿠폰" },
        { value:"mAll", type:"cT" , name: "전체회원용" },
        { value:"pAll", type:"cT" , name: "프리미엄회원용" },
        { value:"sAll", type:"cT" , name: "스탠다드회원용" },
        { value:"sMem", type:"cT" , name: "특정회원한정" },
        { value:"CA"  , type:"cA" , name: "특정카테고리한정" },
        { value:"PD"  , type:"cA" , name: "특정상품한정" }
      ],

      catLimitedCoupon: [],    //카테고리한정상품쿠폰의 카테고리
      pdtLimitedCoupon: [],    //상품한정상품쿠폰의 상품

      showLayer: false,
      layerPosition: { x: 0, y: 0 },
      layerData: null,
      cpIssueQtyIndef: "",      //발행수량 무제한플레그(Y/N)
    };
  },
  created() {
    //this.productId = this.$route.query.productId;
    this.user = this.$store.state.user;

    this.getIssuedCpList()                  //발행된 쿠폰리스트




    this.getHandlerInfo()                   //알림톡 발송대상 체크
  }, 
  // filters: {
  //   currency: function(val) {
  //     var num = new Number(val);
  //     return num.toFixed(0).replacereplace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //   }
  // },
  computed: {
    user() {
      return this.$store.state.user;
    },
    layerStyle() {
      return {
        left: `${this.layerPosition.x}px`,
        top: `${this.layerPosition.y}px`,
        minWidth: '300px',
        maxWidth: '600px',
        background: 'rgba(0,0,0,0.7)',
        opacity: 0.95,
        borderRadius: '8px',
        color: '#fff',
        padding: '20px',
        zIndex: 1000,
        boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
        position: 'absolute',
      }
    }
  },
  mounted() {
    if(document.referrer == "") {
      this.$swal.fire('', '적절하지 않은 페이지 접근입니다.', 'error');
      location.replace("/")
    }
    //권한없는 로그인 차단
    if(this.user.handlerGrade >= 20) {
      var swal = require('sweetalert2');
      swal.fire({
        title: '로그인 필요',
        text: '접근권한 확인불가.',
        icon: 'error'
      });
      this.$router.push({path: '/'});
    }
    ////document.getElementById("notice").style.display = "none";
    document.getElementById("user").style.display = "none";

    //alert(this.today)
  },
  methods: {
    //memberInfo: 회원정보리스트용 sql
    getDateFormat(date) {
      return this.$dateFormat(date);
    },
    // mixins에 있는 공통함수 호출샘플
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },    

    pageReload() {
      this.$swal.fire({
        html: '화면을 초기화하시겠습니까?',
        showCancelButton: true,
        confirmButtonText: "YES",
        cancelButtonText: "NO"
      })
      .then((result) => {
        if(result.isConfirmed)
        {
          location.reload()
        }
      })
    },

    // 상품리스트 검색
    async changeSearchCode(sp){
      await this.getIssuedCpList()
      this.issuedCpList = this.issueCpList_org
      if(sp.value === "All" && sp.type === "aL")
      {
        this.issuedCpList
      }
      else if(sp.type === "cA")
      {
        if(sp.value === "Y")              //활성
        {
          this.issuedCpList = this.issueCpList_org.filter(item => {
            return item.cpActive === "Y"
          })
        }
        else if(sp.value === "N")        //비활성
        {
          this.issuedCpList = this.issueCpList_org.filter(item => {
            return item.cpActive === "N"
          })
        }
        else if(sp.value === "CA")        //특정카테고리
        {
          this.issuedCpList = this.issueCpList_org.filter(item => {
            return item.cpUseCode === "CA"
          })
        }
        else if(sp.value === "PD")        //특정product
        {
          this.issuedCpList = this.issueCpList_org.filter(item => {
            return item.cpUseCode === "PD"
          })
        }
      }
      else if(sp.type === "cT") 
      {
        if(sp.value === "mAll")          //전체회원
        {
          this.issuedCpList = this.issueCpList_org.filter(item => {
            return item.cpType === "mAll"
          })
        }
        else if(sp.value === "pAll")     //프리미엄
        {
          this.issuedCpList = this.issueCpList_org.filter(item => {
            return item.cpType === "pAll"
          })
        }
        else if(sp.value === "sAll")     //standard
        {
          this.issuedCpList = this.issueCpList_org.filter(item => {
            return item.cpType === "pAll"
          })
        }
        else if(sp.value === "sMem")     //특정회원
        {
          this.issuedCpList = this.issueCpList_org.filter(item => {
            return item.cpType === "sMem"
          })
        }
      }
    },

    //쿠폰명 검색
    async searchCoupon(kw) {
      await this.getIssuedCpList()

      //영문이 있는 경우 대소문자 구별X
      this.issuedCpList = this.issueCpList_org.filter(item =>{
        return item.cpName.toLowerCase().includes(kw.toLowerCase());
      })
    },

    async checkData(type, code, event) {
      // 1. 위치 계산
      const rect = event.target.closest('td').getBoundingClientRect()
      this.layerPosition = {
        x: rect.left + window.scrollX,
        y: rect.top + rect.height + window.scrollY
      }

      // 2. 데이터 호출
      try 
      {
        // const res = await this.$axios.get(`/api/${type}/${code}`)
        if(type==="CA") 
        {
          let catLimitedCoupon = await this.$api("/api/catLimitedCoupon", {param: [ code ]})
          this.catLimitedCoupon = catLimitedCoupon
          console.log("catLimitedCoupon:", catLimitedCoupon)
          
          // 1. map()으로 코드명 추출
          this.layerData = catLimitedCoupon?.map(item => item.codeNameKor) || [];
          
          // 2. 데이터 확인용 (옵션)
          if (this.layerData.length === 0) {
            console.warn("지정된 카테고리가 없습니다.");
          }
        }
        else if(type==="PD") 
        {
          let pdtLimitedCoupon = await this.$api("/api/pdtLimitedCoupon", {param: [ code ]})
          this.pdtLimitedCoupon = pdtLimitedCoupon
          console.log("pdtLimitedCoupon:", pdtLimitedCoupon)

          // 1. map()으로 코드명 추출
          this.layerData = pdtLimitedCoupon?.map(item => item.pdtNameKor) || [];
          
          // 2. 데이터 확인용 (옵션)
          if (this.layerData.length === 0) {
            console.warn("지정된 상품이 없습니다.");
          }
        }
        else if(type==="sMem") 
        {
          let pdtMemberCoupon = await this.$api("/api/pdtMemberCoupon", {param: [ code ]})
          this.pdtMemberCoupon = pdtMemberCoupon
          console.log("pdtMemberCoupon:", pdtMemberCoupon)

          // 1. map()으로 코드명 추출
          this.layerData = pdtMemberCoupon?.map(item => `${item.uNickName} (${item.cpMemId}, ${item.mLevel})`) || [];
          
          // 2. 데이터 확인용 (옵션)
          if (this.layerData.length === 0) {
            console.warn("지정된 회원이 없습니다.");
          }
        }
        //this.layerData = res.data
        this.showLayer = true
      } 
      catch (err) 
      {
        console.error(err)
      }
    },
    closeLayer() {
      this.showLayer = false
      this.layerData = null
    },


    //쿠폰무호화
    async changeCpStatus(cc, stat) {    //쿠폰코드, 쿠폰상태
      this.$swal.fire({
        html: '쿠폰의 효력을 변경하시겠습니까?(유효<->무효)',
        showCancelButton: true,
        confirmButtonText: "YES",
        cancelButtonText: "NO"
      })
      .then(async (result) => {
        if(result.isConfirmed)
        {
          let res_changeCpStat = await this.$api("/api/changeCpStat", {param: [ stat, cc ]})

          if(res_changeCpStat.affectedRows > 0)
          {
            this.$swal.fire("", "쿠폰상태가 변경되었습니다", "info")
            .then(() => {
              this.getIssuedCpList()
            })
          }
          else
          {
            this.$swal.fire("", "쿠폰상태가 변경에 오류가 발생했습니댜.", "warning")
            return false;
          }
        }
      })
    },


    async getIssuedCpList() {
      let issuedCpList = await this.$api("/api/issuedCouponList", {});
      if(issuedCpList.length > 0)
      {
        let issueCpList_desc = issuedCpList.sort((a, b) => b.cpSeq - a.cpSeq)      //DESC정렬
        this.issueCpList_org = issueCpList_desc 
        this.issuedCpList = issueCpList_desc
      }
      console.log("issuedCpList::::::", this.issuedCpList)
    },

    // 상품카테고리정보
    async getPdtCategoryList(){
      let pdtCategoryList = await this.$api("/api/pdt_categoryList", {});
      if(pdtCategoryList.length > 0)
      {
        this.pdtCategoryList = pdtCategoryList
      }
    },

    // 카테고리별 검색(A,T,L,E,S,VR,BE)
    changeCatCode(catCode) {
      if(catCode === "A")
      {
        this.cpUseCodeList = this.cpUseCodeList_org
      }
      else
      {
        this.cpUseCodeList = this.cpUseCodeList_org.filter(item => {
          return (item.salesRoute === catCode)
        })
      }

      console.log("cpUseCodeList_org::::::", this.cpUseCodeList_org)
      console.log("cpUseCodeList>>>>>", this.cpUseCodeList)
    },

    allChoice(param) 
    {
      if(param === "CU")        //적용대상
      {
        if(this.allSelected)
        {
          this.cpUseCodeList.forEach((cu) => {
            cu.checkFlag = true;
          })
        }
        else
        {
          this.cpUseCodeList.forEach((cu) => {
            cu.checkFlag = false;
          })
        }
      }
      else if(param === "CT")   //발행대상
      {
        if(this.allSelected_ct)
        {
          this.memberInfo.forEach((m) => {
            m.checkFlag = true;
          })
        }
        else
        {
          this.memberInfo.forEach((m) => {
            m.checkFlag = false;
          })
        }
      }
    },



    // 적용대상 chips에서 삭제
    removeCpUse(idx) {
      this.selectedCpUseArray.splice(idx, 1);
    },

    // 발행대상 chips에서 삭제
    removeCpType(idx) {
      const removed = this.selectedcpTypeArray.splice(idx, 1)[0];
      // selectedMemId_array도 동기화
      this.selectedMemId_array = this.selectedMemId_array.filter(mem => mem.memId !== removed);
    },

    async saveTemp_selItems(flag, param) {
      // 적용대상 스톡
      if(param === "CU") {
        let selectedCpUse = [];
        if(flag === 'CA') {
          this.cpUseCodeList.forEach((cu) => {
            if(cu.checkFlag)
            {
              selectedCpUse.push(
                {
                  code: cu.baseCode,
                  name: cu.codeNameKor
                }
              )
            }

          cu.checkFlag = null

          });
        } 
        else if(flag === 'PD') 
        {
          this.cpUseCodeList.forEach((cu) => {
            if(cu.checkFlag)
            {
              selectedCpUse.push(
                {
                  code: cu.pdtCode,
                  name: cu.pdtNameKor
                }
              );
            }
            cu.checkFlag = null
          });
        }
        if(selectedCpUse.length < 1) {
          this.$swal.fire("","선택된 적용대상이 없습니다.","warning");
          return false;
        }
        // 중복 없이 chips에 추가
        selectedCpUse.forEach(item => {
          //객체전체를 넣는 것이므로 include대신 some을 사용
          if(!this.selectedCpUseArray.some(x => x.code === item.code)) {
            this.selectedCpUseArray.push(item);
          }
        });
        this.$swal.fire("","적용대상이 선택되었습니다","success");
      }

      // 발행대상 스톡
      if(param === 'CT') {
        let selectedcpType_array = [];

        if(flag === 'sMem') {
          this.memberInfo.forEach((m) => {
            if(m.checkFlag) {
              // selectedcpType.push(m.uEmail);
              selectedcpType_array.push({
                memId: m.uEmail,
                memCall: m.alimCallC,
                memName: m.uNickName
              });
            }

            m.checkFlag = null
          });
        }
        if(selectedcpType_array.length < 1) {
          this.$swal.fire("","선택된 발행대상이 없습니다.","warning");
          return false;
        }

        // 중복 체크 후 배열에 추가
        selectedcpType_array.forEach(newMem => {
          if (!this.selectedcpTypeArray.some(x => x.memId === newMem.memId)) { // 🟢 some() 사용
            this.selectedcpTypeArray.push({ 
              memId: newMem.memId, 
              memName: newMem.memName,
              memCall:newMem.memCall
            });
          }
        });

        // send용 배열도 동기화
        selectedcpType_array.forEach(newMem => {
          if (!this.selectedMemId_array.some(mem => mem.memId === newMem.memId)) {
            this.selectedMemId_array.push(newMem);
          }
        });
        this.$swal.fire("","발행대상이 선택되었습니다.","success");
      }
    },

    //쿠폰적용대상리스트표시
    async show_cpUseCodeList(cu, param, prop){

      this.selectedCpUse = []         //선택된 적용대상 초기화

      if(prop != 'search')
      {
        this.selectedCpUseArray = []   //선택표시될 배열값 초기화
      }


      if(param == "")
      {
        if(this.cpActive == "")
        {
          this.$swal.fire("","쿠폰상태를 선택하세요.","warning");
          this.cpUseCode = ""
          return false;
        }
      }
      
      this.getPdtCategoryList()  //상품카테고리정보

      this.keyWord = ""          //검색용 상품명 초기화
      this.show_cpUseCode = "N"  //적용대상 리스트 표시여부 초기화(보이지 않게)
      this.allSelected = "N"     //전체선택 초기화(무선택)

      this.isLoading = true      //로딩시작

      try
      {
        let cpUseCodeList_tmp = []
        let cpUseCodeList_search = []

        if(param == "")
        {
          if( cu === "CA" || cu === "PD")      //특정카테고리 || 특정상품
          {
            this.show_cpUseCode = "Y"
            if(cu === "CA") 
            {
              cpUseCodeList_tmp = await this.$api("/api/pdtCatInfoList", {param: []});
            }
            else if(cu === "PD") 
            {
              cpUseCodeList_tmp = await this.$api("/api/pdtInfoList", { param: [] });
            }
          }
          else
          {
            this.show_cpUseCode = "N"
          }
        }
        else if(param === "Y")
        {
          this.show_cpUseCode = "Y"

          cpUseCodeList_search = await this.$api("/api/pdtInfoListBykeyword", {param: [ cu ]});
        }
        
        // 체인지검색과 입력검색의 결과값 분리
        if(cpUseCodeList_tmp.length > 0)
        {
          this.cpUseCodeList_org = cpUseCodeList_tmp
          this.cpUseCodeList = cpUseCodeList_tmp
        }
        if(cpUseCodeList_search.length>0)
        {
          this.cpUseCodeList = cpUseCodeList_search
        }
      }

      finally
      {
        this.isLoading = false          //로딩종료
      }
    },

    searchProduct(kw, sType, prop){
      if(!kw)
      {
        this.$swal.fire("","검색어를 입력하세요.","warning");
        return false;
      }
      if(sType === "CU")
      {

        this.show_cpUseCodeList(kw, "Y", prop)
      }
      else if(sType === "CT")
      {
        this.getMemberList(kw)
      }
      // this.show_cpUseCodeList(kw, "Y")
    },


    // 발행대상 리스트처리
    async show_cpTypeList(ct, param){

      this.selectedcpType = []        //선택된 발행대상 초기화
      this.selectedcpTypeArray = []   //선택된 발행대상 스톡초기화
      
      if(param == "")
      {
        if(this.cpUseCode == "")
        {
          this.$swal.fire("","쿠폰적용대상을 선택하세요.","warning");
          this.cpType = ""
          return false;
        }
      }

      this.show_cpType = "Y"

      this.getMemberList();

      this.keyWord = ""          //검색용 상품명 초기화
      // this.show_cpType = "N"  //적용대상 리스트 표시여부 초기화(보이지 않게)
      this.allSelected = "N"     //전체선택 초기화(무선택)
    },


    //회원정보리스트
    async getMemberList(kw) {

      this.isLoading = true     //로딩시작

      try
      {
        let memberInfo = await this.$api("/api/memberInfoList", {});

        if(memberInfo.length > 0)
        {
          this.memberInfo_org = memberInfo           //for 조건별 소팅

          this.memberInfo = memberInfo
        }

        //회원검색처리
        if(kw != "" && kw != undefined)
        {
          this.memberInfo = this.memberInfo_org.filter(item => {
            return (item.uNickName.toLowerCase().includes(kw.toLowerCase()))
          })
        }
      }
      finally
      {
        this.isLoading = false          //로딩종료
      }
    },

    //검색조건변경
    async changeProcCode(param) {
      if(param === 'A') 
      {
        this.getMemberList();
      }
      else if(param === "Pre")
      {
        this.memberInfo = this.memberInfo_org.filter(item => {
          return (item.memLevel === 'P' && item.testFlag != 'Y')
        })
      }
      else if(param === "Std")
      {
        this.memberInfo = this.memberInfo_org.filter(item => {
          return (item.memLevel === 'S' && item.testFlag != 'Y')
        })
      }
    },

    //쿠폰코드생성 후 발행리스트에 저장처리
    async genCpCode(cpQty) {
      let today = new Date();
      let yy = today.getFullYear().toString().slice(-2);
      let mm = today.getMonth() + 1;
      let dd = today.getDate();
      let ymd = `${yy}${mm}${dd}`;
      // let dCd = param + ymd;
      return await generateCouponCode(this.$api, ymd, cpQty);
    },

    //쿠폰생성
    async makeCoupon(){
      // console.log("선택된 회원:>>>>>>>>", this.selectedMemId_array)
      if(!this.cpActive){
        this.$swal.fire("","쿠폰상태를 선택하세요.","warning");
        return false;
      }
      if(!this.cpUseCode){
        this.$swal.fire("","쿠폰적용대상을 선택하세요.","warning");
        return false;
      }
      if(!this.cpType && this.cpActive === 'active'){
        this.$swal.fire("","쿠폰발행대상을 선택하세요.","warning");
        return false;
      }
      if(!this.cpName){
        this.$swal.fire("","쿠폰명을 입력하세요.","warning");
        return false;
      }
      if(!this.cpPrice){
        this.$swal.fire("","쿠폰적용금액을 입력하세요.","warning");
        return false;
      }
      if(!this.cpPriceFlag){
        this.$swal.fire("","쿠폰적용금액 단위를 선택하세요.","warning");
        return false;
      }
      if(this.firstQty<0){
        this.$swal.fire("","쿠폰발행수량을 확인하세요.","warning");
        return false;
      }
      if(!this.cpIssueDate){
        this.$swal.fire("","쿠폰발행일자를 입력하세요.","warning");
        return false;
      }
      if(!this.cpExpDate){
        this.cpExpIndef = "Y"     //무제한
        this.cpExpDate = "2999-12-31"
      }
      else{
        this.cpExpIndef = "N"     //기한부
      }      
      if(!this.cpIssuer){
        this.$swal.fire("","쿠폰발행자를 입력하세요.","warning");
        return false;
      }
      if(this.firstQty == 0){
        this.cpIssueQtyIndef = "Y"  // 수량무제한
      }
      else if(this.firstQty > 0){
        this.cpIssueQtyIndef = "N"  // 수량제한
      }
      else if(this.firstQty < 0){
        this.$swal.fire("","발행수량에 오류가 있습니다.","warning");
        return false;
      }      

      // 쿠폰코드를 생성하고 수량을 발행리스트에 저장처리
      let cpCode_rtn  = await this.genCpCode(this.firstQty);
      
      let cpCode = ""
      if(cpCode_rtn == "noCpCode")
      {
        this.$swal.fire("", "쿠폰코드가 계속 중복되어 발생하고 있습니다. 개발자에게 연락해주세요!")
        return false
      }
      else
      {
        cpCode = cpCode_rtn
        this.cpCode = cpCode
      }

      let cpActive    = this.cpActive == 'active' ? 'Y' : 'N'
      let cpUseCode   =  this.cpUseCode
      let cpType      =  this.cpType
      let cpName      =  this.cpName
      let cpPrice     =  this.cpPrice
      let cpPriceFlag =  this.cpPriceFlag
      let cpIssueQty  =  0
      let cpIssueDate =  this.cpIssueDate
      let cpExpDate   =  this.cpExpDate
      let cpIssuer    =  this.cpIssuer
      let cpRemarks   =  this.cpRemarks
      let cpInsId     = this.user.handlerId
      let cpValidFlag = "Y"
      let cpWithPoint = "N"
      let cpExpIndef  = this.cpExpIndef
      let cpIssueQtyIndef  = this.cpIssueQtyIndef
      let firstQty    = this.firstQty

      //쿠폰생성
      let makeCoupon = await this.$api("/api/proc_makeUserCoupon", {param: [
        cpActive, cpCode, cpUseCode, cpType, cpName, cpPrice, cpPriceFlag, cpIssueQty, cpIssueDate, cpIssuer, cpExpDate, cpRemarks, cpInsId, cpValidFlag, cpWithPoint, cpExpIndef, cpIssueQtyIndef, firstQty
      ]});
      
      const affectedRows = makeCoupon[0][0]?.affectedRows || 0; // 결과 구조 확인

      if(affectedRows > 0) 
      {
        //적용대상 DB저장
        if(this.cpUseCode === "CA" || this.cpUseCode === "PD")
        {
          if(this.cpUseCode === "CA")
          {
            const promises = this.selectedCpUseArray.map(cu => {
              let cpCode = this.cpCode
              let cpCat = cu.code
              let cpPdtCode = ""
              return this.$api("/api/insCuponDetail_cu", {param: [ cpCode, cpCat, cpPdtCode ]})
              .then(response => ({ success: response?.affectedRows > 0}))
              .catch(() => ({ success: false}))
            })

            const results = await Promise.all(promises)
            const fails = results.filter(r => !r.success)

            if(fails.length > 0)
            {
              this.$swal.fire("", "적용대상(카테고리) 저장 중 오류발생!", "error")
            }
            
          }
          else if(this.cpUseCode === "PD")
          {
            const promises = this.selectedCpUseArray.map(cu => {
              let cpCode = this.cpCode
              let cpCat = ""
              let cpPdtCode = cu.code
              return this.$api("/api/insCuponDetail_cu", {param: [ cpCode, cpCat, cpPdtCode ]})
              .then(response => ({ success: response?.affectedRows > 0}))
              .catch(() => ({ success: false}))
            })

            const results = await Promise.all(promises)
            const fails = results.filter(r => !r.success)

            if(fails.length > 0)
            {
              this.$swal.fire("", "적용대상(상품정보) 저장 중 오류발생!", "error")
            }
          }
        }

        if(this.cpType === 'sMem')
        {
          const promises = this.selectedcpTypeArray.map(ct => {
            let cpCode = this.cpCode
            let cpMemId = ct.memId
            return this.$api("/api/insCuponDetail_ct", {param: [ cpCode, cpMemId ]})
            .then(response => ({ success: response?.affectedRows > 0}))
            .catch(() => ({ success: false}))
          })

          const results = await Promise.all(promises)
          const fails = results.filter(r => !r.success)

          if(results.length > 0)
          {
            // 지정대상 쿠폰발송
            await this.sendCpToMember(this.selectedMemId_array, cpCode)
          }
          else if(fails.length > 0)
          {
            this.$swal.fire("", "쿠폰발행대상 저장처리 중 오류가 발생했습니다.", "error")
            return false;
          }
        }
        else
        {
          this.$swal.fire('', '쿠폰이 생성되었습니다', 'success')
          .then(() => {
            //location.reload(true)
            this.getIssuedCpList()
            this.cpActive = ""
          })
        }
      }
      else
      {
        console.log("cpUseCode>>", this.cpUseCode, "cpType>>", this.cpType)
        this.$swal.fire('', '쿠폰생성에 실패했습니다', 'error')
        return false;
      }
    },

    async sendCpToMember(mList, cpCode) {
      // 병렬처리로직
      const promises = mList.map(user => {
        let uEmail = user.memId;
        let uCall = user.memCall;
        let cpUseFlag = "N";
        return this.$api("/api/proc_sendUserCoupon", {param: [uEmail, cpCode, cpUseFlag, uCall]})
          .then(response => ({userId: uEmail, success: response[0][0]?.affectedRows > 0}))
          .catch(() => ({userId: uEmail, success: false}));
      });

      const results = await Promise.all(promises);
      const failedUsers = results.filter(r => !r.success).map(r => r.userId);

      console.log("results:", results, "failedUsers:", failedUsers)

      if (failedUsers.length > 0) 
      {
        this.$swal.fire('', `쿠폰등록에 실패한 사용자 ID: ${failedUsers.join(", ")}=>쿠폰을 생성해주세요`, 'error');
      } 
      else 
      {
        this.$swal.fire('', '쿠폰이 생성되었습니다', 'success')
        .then(() => {
          //location.reload(true)
          this.getIssuedCpList()
          this.cpActive = ""
        })
      }
    },




    async getHandlerInfo()
    {
      let handTel = await handlerInfo(this.$api);
      if(handTel.length > 0)
      {
        this.handTel = handTel
      }
    },

    /** 멤버십가입 카카오알림 발송 */
    async sendKakao(param, payDate, expDate, in_memLevel, uEmail, alimCallC, uNickName)
    {
      console.log(param, payDate, expDate, in_memLevel, uEmail, alimCallC, uNickName)

      //연락처를 발송용으로 컨버전
      //let alimCallC = ""
      if(alimCallC.charAt(0) === "+")
      {
        alimCallC = alimCallC.replace("+82 ", "0")
      }
      alimCallC = alimCallC.replace(/-/g,"")
      console.log("alimCallC:>>>>>>", alimCallC)


      let insKSendHistory = await this.$api("/api/insKSendHistory", {param: [
        uEmail, param, alimCallC
      ]});

      //알림톡 발송대상 확정
      this.handTel.push({aimCall: alimCallC})
      this.handTelCnt = this.handTel.length

      if(insKSendHistory.affectedRows > 0) 
      {
        let promises = []         //promise들의 배열

        let membership = ""
        let mPayAmt = 0
        if(in_memLevel === "P")
        {
          membership = "엔데이트립 프리미엄멤버십"
          mPayAmt = "199,000"
        }
        else if(in_memLevel == "S") 
        {
          membership = "엔데이트립 스탠다드멤버십"
          mPayAmt = "99,000"
        }
        // else if(in_memLevel == "ES" || in_memLevel == "EP") 
        // {
        //   membership = "엔데이트립 멤버십연장"
        // }        
        //console.log(membership)


        //결제요청 카카오 알림톡(결제자)
        let i = 0
        while(i < this.handTelCnt)
        {
          let kakaoAlimData = 
          {
            //카카오 알림톡 발송(결제완료)
            clientName: uNickName,
            membership: membership,
            memPayDate: payDate,
            memPayAmt: mPayAmt,
            memExpDate: expDate,
            resCode: "",
            alimFlag: param, //알림유형(결제요청)
            clientCall: this.handTel[i].aimCall,                                //알림톡발송대상
          };

          let promise = this.$api("api/kakaoAlimSend6", {
            param: [{ kakaoAlimData: kakaoAlimData}]
          })

          promises.push(promise)
          i++
        }

        //반복문 이후 처리
        Promise.all(promises).then((results) => {
          console.log(results)
          this.$swal.fire('', '멤버십가입 알림톡이 발송되었습니다', 'success').then(() => {
            location.reload(true)
          })
        }).catch((error) => {
          console.log("Error calling api: ", error)
        })        
      }
    },
  }
}
</script>

<style scoped>
 /* input의 폭을 td에 맞춤 */
  input {
    width: 100%;
    box-sizing: border-box;
  }

  /*******************
    # 선택아이템 칩스처리
  **********************/
  #stockTable .stockTable{
    border: 3px solid darkgray;
  }
  #stockTable .chips-container {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    min-height: 40px;
    padding: 4px;
  }
  #stockTable .chip {
    background: #e0e0e0;
    border-radius: 16px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    font-size: 0.8rem;
    margin-bottom: 4px;
  }
  #stockTable .chip-close {
    background: none;
    border: none;
    margin-left: 6px;
    cursor: pointer;
    font-weight: bold;
    font-size: 1rem;
    color: #555;
  }
  #stockTable .chip-close:hover {
    color: #f00;
  }
  

  /****************************
    # 레이어 표시
  *******************************/
  .data-layer {
    position: absolute;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(5px);
    border-radius: 8px;
    color: white;
    padding: 20px;
    z-index: 1000;
    box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  }
  
  .layer-content {
    position: relative;
    height: 100%;
    padding-top: 20px; /* 닫기버튼 높이만큼 위에 여백 */
    overflow: auto;
  }
  
  .close-btn {
    position: absolute;
    right: 5px;
    top: 0px;
    background: none;
    border: none;
    color: yellow;
    font-size: 24px;
    cursor: pointer;
  }

  .layerData {
    margin-top: 15px;
    text-align: left;
    font-size: 1em;
    word-break: keep-all;
  }  
</style>